module.exports = __webpack_public_path__ + "img/indigent1_7-8-2021.a659380f.jpg";